<template>
    <div class="document-page">
        文档
    </div>
</template>
<script>
export default {
    name: "document-page",
    data() {
        return {}
    }
}
</script>
<style scoped>
.document-page {
    width: 100%;
    height: 100%;
    margin: 0;
    padding: 0;
    text-align: center;
}
</style>